// Сервис фичи «сканер меню» (фото → блюда). Контракт совпадает с бэком
// backend/src/modules/menu-scan. Цены в рублях; в копейки конвертит сервер на import.
import { api, post } from './api';

export type ScanVariant = {
  label: string; // "0.2","S","500мл"; "" = одиночная цена
  priceRub: number | null;
  priceMaxRub?: number | null; // диапазон «300-600»
  note?: string;
};
export type ScannedItem = {
  tempId: string;
  kind: 'dish';
  category: string;
  categoryId: string | null; // матч с существующей категорией, иначе null
  name: string;
  variants: ScanVariant[];
  confidence: number;
};
export type ScannedModifier = { tempId: string; name: string; priceRub: number; note?: string };
export type ScanResult = {
  scanId: string;
  imageUrl?: string;
  items: ScannedItem[];
  modifiers: ScannedModifier[];
  warnings: string[];
};

// multipart — как uploadImage в admin.ts (api.post напрямую). Таймаут больше:
// распознавание в LLM дольше дефолтных 15с.
export async function scanMenu(file: File): Promise<ScanResult> {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await api.post<ScanResult>('/api/admin/menu/scan', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 90_000,
  });
  return data;
}

export type ImportDish = {
  categoryId?: string;
  categoryName?: string;
  name: string;
  priceRub: number;
  weight?: string;
  section?: 'KITCHEN' | 'BAR' | 'NONE';
};
export type ImportModifier = { name: string; priceRub: number };
export type ImportResult = {
  createdCategories: number;
  createdDishes: number;
  createdModifiers: number;
  skipped: number;
  items: Array<{ name: string; dishId?: string; status: string; categoryId?: string }>;
};
export const importMenu = (dishes: ImportDish[], modifiers: ImportModifier[], dedupe = true) =>
  post<ImportResult>('/api/admin/menu/import', { dishes, modifiers, dedupe });
